import axios from "axios";
import { config } from "./api.config";

export class ApiService {
    url = config.api.baseUrl;

    // post request to craete a new request
    post(url, data) {
        const responseType =  'json';
        return axios.post(url, data, { responseType });
    }    

    // put request to update whole data the data
    put(url, data) {
        return axios.put(url, data);
    }

    // get request to get data
    get(url, params, options = {}) {
        return axios.get(url, {params,signal: options.signal,});
    }

    // delete request to delete data
    delete(url) {
        return axios.delete(url);
    }
}